/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  FLink,
  Table,
  CurrencyTextInput,
  TableMobile,
  Datepicker,
  Button,
  LoadingIndicator,
} from '@components';
import { currency } from '@utils';
import { useSelector } from 'react-redux';
import { addDays, format } from 'date-fns';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';
import { EmprestimoService } from '../../../../../common/services/emprestimo';

const service = new EmprestimoService();

export const Amortizacao = () => {
  const { id } = useParams();
  const location = useLocation();
  const {
    vlrSolicitado,
    parcTotal,
    parcPagas,
    ultimaParcela,
    vlrSaldoDevedor,
    totalParcelasEmAtraso,
    valorTotalEmAtraso,
  } = location.state;

  const navigate = useNavigate();

  const [valor, setValor] = useState(0);
  const [dataPagamento, setDataPagamento] = useState(new Date());
  const [dataFormatada, setDataFormatada] = useState('');

  const [novaPrestacao, setNovaPrestacao] = useState('0');

  const [loading, setLoading] = useState(false);
  const [simulou, setSimulou] = useState(false);

  const {
    matricula,
    token,
    dadosPessoais: { email },
  } = useSelector((state) => state.user);

  useEffect(() => {
    setDataFormatada(format(dataPagamento, 'yyyy-MM-dd'));
  }, [dataPagamento]);

  const valorEmCentavos = (valor * 100).toFixed(0);

  const geraBoletoAmortizacao = () => {
    service
      .emitirBoletoEmprestimo({
        matricula,
        email,
        numeroContrato: id,
        token,
        dataVencimento: dataFormatada,
        valor: valorEmCentavos,
        tipoPagamento: 'Amortização',
      })
      .then((res) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Boleto Amortização - ${matricula}.PDF`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  return (
    <div className="card">
      <div className="card-body">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-2">
          Amortização do contrato: {id}
        </h3>
        <p className="ts-14 text-muted mb-32">
          Modalidade de pagamento em que o prazo final do contrato é mantido e o
          valor da parcela é reduzido. Não pode ocorrer mais de um pagamento
          dentro do mês corrente.
        </p>
        <Table
          large
          odd
          className="is-desktop mb-32"
          columns={[
            'Valor',
            'Parcelas',
            'Lançadas',
            'Última',
            'Saldo devedor',
            'Atrasadas',
            'Valor em atraso',
          ]}
        >
          <tr>
            <td className="ts-20">{currency(vlrSolicitado)}</td>
            <td className="ts-20">{parcTotal}</td>
            <td className="ts-20">{parcPagas}</td>
            <td className="ts-20">{currency(ultimaParcela)}</td>
            <td className="ts-20">{currency(vlrSaldoDevedor)}</td>
            <td className="ts-20">{totalParcelasEmAtraso}</td>
            <td className="ts-20">{currency(valorTotalEmAtraso)}</td>
          </tr>
        </Table>
        <TableMobile className="mb-32">
          <div className="col-6">
            <div className="thead">Valor</div>
            <div className="td">{currency(vlrSolicitado)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Parcelas</div>
            <div className="td">{parcTotal}</div>
          </div>
          <div className="col-6">
            <div className="thead">Lançadas</div>
            <div className="td">{parcPagas}</div>
          </div>
          <div className="col-6">
            <div className="thead">Última</div>
            <div className="td">{currency(ultimaParcela)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Saldo devedor</div>
            <div className="td">{currency(vlrSaldoDevedor)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Atrasadas</div>
            <div className="td">{totalParcelasEmAtraso}</div>
          </div>
          <div className="col-12">
            <div className="thead">Valor em atraso</div>
            <div className="td">{currency(valorTotalEmAtraso)}</div>
          </div>
        </TableMobile>
        <div className="row">
          <div className="is-desktop col-12 col-md-5 col-lg-4">
            <CurrencyTextInput
              height={56}
              fontSize="ts-16 border-50"
              label="Qual valor deseja amortizar"
              value={valor}
              onChange={(value) => setValor(value)}
            />
          </div>
          <div className="is-mobile col-12 col-md-5 col-lg-4 mb-32">
            <CurrencyTextInput
              label="Qual valor deseja amortizar"
              value={valor}
              onChange={(value) => setValor(value)}
            />
          </div>
          <div className="col-12 col-md-3 col-lg-3">
            <Datepicker
              label="Data de pagamento"
              value={dataPagamento}
              min={new Date()}
              max={addDays(new Date(), 1)}
              onChange={setDataPagamento}
            />
          </div>
          <Button
            className="mt-3"
            onClick={() => {
              setLoading(true);

              service
                .obterCalculoAmortizacao({
                  contrato: id,
                  data: dataFormatada,
                  matricula,
                  valor,
                  token,
                })
                .then((res) => {
                  setNovaPrestacao(res);
                })
                .finally(() => {
                  setLoading(false);
                  setSimulou(true);
                });
            }}
          >
            Simular amortização
          </Button>
        </div>
      </div>

      {loading ? (
        <LoadingIndicator />
      ) : (
        simulou && (
          <div className="p-41 mb-32">
            <div className="row">
              <hr className="mb-32" />
              <h4 className="fs-3 mb-3 fw-bold">Resultado da simulação:</h4>
              <div className="d-flex">
                <p className="fs-5 mb-2 flex-1">
                  Valor da amortização: {currency(valor)}
                </p>
                <p className="fs-5 mb-2 flex-1">
                  Valor da nova prestação: {currency(Number(novaPrestacao))}
                </p>
              </div>
            </div>
          </div>
        )
      )}

      {!loading && simulou && (
        <div className="card-footer">
          <hr className="mb-32" />
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 ms-0 ms-sm-auto">
              <Button
                onClick={geraBoletoAmortizacao}
                transparent
                color="orange"
              >
                Gerar boleto
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
